




















import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'

@Component({
  components: {}
})
export default class TestPoint extends ViewBase {
  @Prop({ default: null }) pointsStatistical!: any
  @Prop({ default: 0 }) time!: number
  lang: any = {}

  echartSource: any = []
  // 鼠标指到柱状图上的提示文字
  textArr: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  onStudentChange(value: any) {}

  drawLine() {}

  created() {
    this.lang = this.i18n.vClients
    setTimeout(() => {
      this.drawLine()
    })
  }
  @Watch('time')
  watchTime() {
    this.drawLine()
  }
}
